module.exports = __webpack_public_path__ + "img/组10@2x.a817382a.png";